import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertImmutableauditunreadCountSlice = createApi(`GetAlertImmutableauditunreadCountSlice`,"GET");

const GetAlertImmutableauditunreadCountSlice = createSlice({
  name: 'GetAlertImmutableauditunreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertImmutableauditunreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertImmutableauditunreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertImmutableauditunreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertImmutableauditunreadCountSlice.reducer;